<template>
  <div
    id="kyc-container"
    class="kyc-container"
  >
    <vue-element-loading
      :active="loadingText !== ''"
      :text="loadingText"
      :text-style="{fontSize: '18px', color: '#2193ff', fontWeight: 'bold' }"
      is-full-screen
      spinner="bar-fade-scale"
      color="#2193ff"
      background-color="rgba(255, 255, 255, 0.5)"
      size="100"
    />
    <div class="kyc-container--item">
      <Header/>
    </div>
    <div class="section-gray">
      <div class="kyc-container--content">
        <div class="section-white">
          <KulapPlusKycCard />
        </div>
        <!-- <Steps
          :steps="steps"
          :current-step="currentStep"
          class="steps"
        /> -->
        <!-- <div class="number-steps">
          {{ currentStep + 1 }} / {{ steps.length }}
        </div> -->
        <!-- <div class="section-white">
          <div class="kyc-title-header-wrap">
            <img
              src="/static/svg/icon-kyc-kulap-plus.svg"
              class="kyc-icon-maintenance"
            >
          </div>
          <div class="kyc-title">
            {{ $t('kyc.verify_kulap_plus_title') }}
          </div>
          <div class="kyc-detail-wrap">
            <div class="kyc-detail">
              {{ $t('kyc.verify_kulap_plus_detail') }}
              <a
                :href="kulapPlusNewKycLink"
                target="_blank"
                class="kyc-status-link"
              >
                {{ $t('kyc.verify_kulap_plus_link_text') }}
              </a>
            </div>
          </div>

        </div> -->
        <!--  Card maintenance message -->
        <!-- <div class="section-white">
          <div class="kyc-title-header-wrap">
            <img
              src="/static/img/maintenance-icon.png"
              class="kyc-icon-maintenance"
            >
          </div>
          <div class="kyc-title">
            {{ $t('kyc.maintenance_header') }}
          </div>
          <div class="kyc-subtitle">
            {{ $t('kyc.maintenance_info') }}
          </div>
        </div> -->

        <!-- <div class="section-white">
          <Nationality
            v-if="currentStep === 0"
            :form.sync="form"
            :countries="countries"
            @trackInputForm="trackInputForm"
          />
          <PersonalInformation
            v-else-if="currentStep === 1 && form.customerType === 'Personal'"
            :form.sync="form"
            :countries="countries"
            :occupation-list="occupationList"
            :average-income-list="averageIncomeList"
            :provinces-in-thailand="provincesInThailand"
            @trackInputForm="trackInputForm"
          />
          <OrgInformation
            v-else-if="currentStep === 1 && form.customerType === 'Organization'"
            :form.sync="form"
            :countries="countries"
            :provinces-in-thailand="provincesInThailand"
            :business-list="businessList"
            :average-income-list="averageIncomeList"
            @trackInputForm="trackInputForm"
          />
          <Address
            v-else-if="currentStep === 2"
            :form.sync="form"
            :countries="countries"
            :provinces-in-thailand="provincesInThailand"
            @trackInputForm="trackInputForm"
          />
          <Identify
            v-else-if="currentStep === 3"
            :form.sync="form"
            @trackInputForm="trackInputForm"
          />
          <SummaryPersonal
            v-else-if="(currentStep === 4 || currentStep === 5) && form.customerType === 'Personal'"
            :form="form"
            :current-step="currentStep"
            :provinces-in-thailand="provincesInThailand"
            :occupation-list="occupationList"
            :average-income-list="averageIncomeList"
            @trackInputForm="trackInputForm"
          />
          <SummaryOrganization
            v-else-if="(currentStep === 4 || currentStep === 5) && form.customerType === 'Organization'"
            :form="form"
            :current-step="currentStep"
            :provinces-in-thailand="provincesInThailand"
            :occupation-list="occupationList"
            :business-list="businessList"
            :average-income-list="averageIncomeList"
            @trackInputForm="trackInputForm"
          />
        </div>
        <div v-if="currentStep === 1 && form.customerType === 'Organization'">
          <div class="kyc-title">
            {{ $t('kyc.auth_represent') }}
            <div class="kyc-subtitle">
              ({{ $t('kyc.auth_represent_subtitle') }})
            </div>
          </div>
          <div class="section-white">
            <AuthorizedRepresentative
              :form.sync="form"
              :occupation-list="occupationList"
              @trackInputForm="trackInputForm"
            />
          </div>
        </div>
        <div
          v-if="currentStep <= 4"
          :class="[
            'is-button',
            { 'submit-btn': currentStep === 4 },
            { 'full-next-btn': currentStep === 0 },
            { 'next-btn': currentStep > 0 && currentStep < 4 }
          ]"
          data-test="kyc--next-btn"
          @click="clickNextStepButton"
        >
          {{ currentStep === 4 ? $t('buttons.submit') : $t('buttons.next') }}
        </div>
        <div
          v-if="currentStep <= 4"
          v-show="currentStep > 0"
          class="is-button back-btn"
          @click="clickBackStepButton"
        >
          {{ $t('buttons.back') }}
        </div> -->
      </div>
    </div>
    <div class="kyc-container--item">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from '@/features/Header'
import Steps from '@/components/Steps'
import Footer from '@/components/Footer'
import Service from './service.js'
import { kulapApi, awsS3Api } from '@/resources'
import cookie from '@/utils/cookie'
import PersonalInformation from './components/Personal/Information'
import SummaryPersonal from './components/Personal/Summary'

import OrgInformation from './components/Organization/Information'
import AuthorizedRepresentative from './components/Organization/AuthorizedRepresentative'
import SummaryOrganization from './components/Organization/Summary'

import Nationality from './components/Nationality'
import Address from './components/Address'
import Identify from './components/Identify'
import KulapPlusKycCard from './components/kulapPlusKycCard'

import { showToastError, parseStringToDate, base64toBlob, formatDate } from '@/utils/helper'
import AmplitudeService from '@/services/amplitude'

export default {
  name: 'KYC',
  components: {
    Header,
    Footer,
    Steps,
    Nationality,
    PersonalInformation,
    OrgInformation,
    AuthorizedRepresentative,
    Address,
    Identify,
    SummaryOrganization,
    SummaryPersonal,
    KulapPlusKycCard
  },
  data () {
    return {
      service: null,
      currentStep: 0,
      form: {
        originPostcode: '',
        originCity: '',
        currentPostcode: '',
        currentCity: '',
        workingAtCompanyPostcode: '',
        workingAtCompanyCity: '',
        workingAtCompanyProvince: '',
        orgCompanyPostcode: '',
        orgCompanyCity: '',
        orgCompanyProvince: ''
      },
      loadingText: '',
      countries: [],
      provincesInThailand: [],
      occupationList: [],
      businessList: [],
      averageIncomeList: []
    }
  },
  computed: {
    steps () {
      return [
        this.$t('kyc.nationality'),
        this.$t('kyc.information'),
        this.$t('kyc.address'),
        this.$t('kyc.identification'),
        this.$t('kyc.summary')
      ]
    },
    kycTitle () {
      if (this.currentStep === 0) {
        return this.$t('kyc.customer_nationality')
      } else {
        if (this.form.customerType === 'Personal') {
          if (this.$i18n.locale !== 'th') {
            return this.currentStep !== 4 ? `Customer ${this.steps[this.currentStep]}` : this.steps[this.currentStep]
          } else {
            return this.currentStep < 3 ? `${this.steps[this.currentStep]}ของลูกค้า` : this.steps[this.currentStep]
          }
        } else {
          if (this.currentStep === 1) {
            if (this.$i18n.locale !== 'th') {
              return `Organization ${this.steps[this.currentStep]}`
            } else {
              return `${this.steps[this.currentStep]}ของบริษัท`
            }
          } else if (this.currentStep !== 4) {
            if (this.$i18n.locale !== 'th') {
              return `Authorized Representative ${this.steps[this.currentStep]}`
            } else {
              return `${this.steps[this.currentStep]}ของตัวแทนผู้มีอำนาจ`
            }
          } else {
            return this.steps[this.currentStep]
          }
        }
      }
    }
  },
  async created () {
    this.persistDataInLocalStorage()
    if (!cookie.get('user') || !cookie.get('accessToken')) {
      this.$router.push({ name: 'Login', query: { next: 'KYC' } })
      return
    }
    this.service = new Service({
      store: this.$store,
      kulapApi,
      awsS3Api
    })
    const user = await this.service.getUserProfile()
    if (!user.isActive) {
      this.$router.push({ name: 'Exchange' })
    } else if (user.kycStatus !== 'UNVERIFIED') {
      this.$router.push({ name: 'SummaryOfKYC' })
    }
    const kulapUtilityFile = await this.service.getKulapUtilityFile()
    this.countries = kulapUtilityFile.countries
    this.provincesInThailand = kulapUtilityFile.provincesInThailand
    this.occupationList = kulapUtilityFile.occupationList
    this.businessList = kulapUtilityFile.businessList
    this.averageIncomeList = kulapUtilityFile.averageIncomeList
  },
  methods: {
    async clickNextStepButton () {
      this.$validator.resume()
      const validateFieldResult = await this.$validator.validate()
      if (!validateFieldResult) {
        const convertNameToId = Object.keys(this.errors.collect())[0].toLowerCase().replace(/ /g, '-').replace(/[()?.]/g, '')
        this.$scrollTo(`#${convertNameToId}`)
        return
      }
      try {
        if (this.currentStep < 4) {
          this.currentStep++
        } else {
          let expectedFormData = Object.assign({}, this.form)
          expectedFormData = this.validateFormBeforeSubmit(expectedFormData)
          expectedFormData = await this.uploadDocsBeforeSubmit(expectedFormData)
          this.loadingText = `${this.$t('messages.submitting_your_info')}...`
          const result = await this.service.submitKyc(expectedFormData)
          this.loadingText = ''
          if (result.success) {
            localStorage.removeItem('persist:kyc-page') // clear persistet localStorage
            this.currentStep++
          } else {
            this.$buefy.toast.open({
              message: `Sorry, something went wrong.`,
              type: 'is-danger'
            })
          }
        }
        this.$scrollTo('#kyc-container')
      } catch (e) {
        showToastError(e)
        this.loadingText = ''
      }
    },
    clickBackStepButton () {
      this.currentStep--
      this.$scrollTo('#kyc-container')
    },
    trackInputForm ({ key, name, page }) {
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.resume()
        let isValid
        setTimeout(async () => {
          try {
            isValid = await this.$validator.validate(name)
          } catch (error) {
            isValid = undefined
          }
          const eventType = `EVENT_KYC_PAGE_${page}_FLOW`
          AmplitudeService.inputField(key, isValid, eventType)
        }, 100)
      })
    },
    persistDataInLocalStorage () {
      this.$persist(['form'], 'persist:kyc-page')
      // delete object data is empty except inputFileSelfie and inputFileIdCard
      Object.keys(this.form).forEach(key => {
        const value = this.form[key]
        if (value === null ||
          (typeof value === 'object' &&
          Object.keys(value).length === 0 &&
          !['inputFileSelfie', 'inputFileIdCard'].includes(key))
        ) {
          delete this.form[key]
        }
      })
      this.form = parseStringToDate(this.form)
    },
    validateFormBeforeSubmit (form) {
      if (form.nationality !== 'Thai') {
        delete form.firstNameInThai
        delete form.lastNameInThai
        delete form.laserCode
      }
      if (form.customerType !== 'Organization') {
        delete form.orgCompanyCert
        delete form.orgShareholders
        delete form.orgSealCert
        delete form.orgHouseRegisAuthDirector
        delete form.orgPowerAttorney
      }
      if (form.isLifetime) {
        form.expireDateOfId = 'Lifetime ID Card'
      } else {
        form.expireDateOfId = formatDate(form.expireDateOfId, 'YYYY-MM-DD').toString()
      }
      delete form.isLifetime
      form.birthdate = formatDate(form.birthdate, 'YYYY-MM-DD').toString()
      form.issueDateOfId = formatDate(form.issueDateOfId, 'YYYY-MM-DD').toString()

      return form
    },
    async uploadDocsBeforeSubmit (form) {
      const listOfDocs = {
        identificationPicture: this.$t('kyc.photo_id_card').toLowerCase(),
        selfIdentificationPicture: this.$t('kyc.photo_selfie').toLowerCase(),
        governmentIssued: this.$t('kyc.gov_issued').toLowerCase(),
        proofOfIncome: this.$t('kyc.proof_of_income').toLowerCase(),
        assetOwnership: this.$t('kyc.evidence_assets').toLowerCase(),
        orgCompanyCert: this.$t('kyc.comp_cert_doc').toLowerCase(),
        orgShareholders: this.$t('kyc.list_shareholders_doc').toLowerCase(),
        orgSealCert: this.$t('kyc.seal_cert_doc').toLowerCase(),
        orgHouseRegisAuthDirector: this.$t('kyc.copy_house_registration').toLowerCase(),
        orgPowerAttorney: this.$t('kyc.power_attorney_lowercase')
      }
      const intersecKeys = Object.keys(listOfDocs).filter(key => Object.keys(form).includes(key))
      const promiseTasks = []
      intersecKeys.forEach(value => {
        const task = new Promise(async (resolve) => {
          try {
            if (/data:image/.test(form[value])) { // value is base64
              const blobImage = await base64toBlob(form[value])
              form[value] = await this.service.postUploadKycDocs(blobImage, value)
            } else if (/application\/pdf|image\/*/.test(form[value].type)) { // value is image or pdf file
              form[value] = await this.service.postUploadKycDocs(form[value], value)
            }
            resolve(true)
          } catch (e) {
            if (e.message.includes('timeout')) {
              showToastError({ message: 'Please check your internet connection and try again.' })
            } else {
              showToastError(e)
            }
            this.loadingText = ''
          }
        })
        promiseTasks.push(task)
      })
      this.loadingText = 'Uploading documents...'
      await Promise.all(promiseTasks)
      delete form.inputFileSelfie
      delete form.inputFileIdCard

      return form
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card {
  margin: 0 auto !important;
  max-width: 550px;
  max-height: 550px;
}
.modal-body {
  width: 100%;
  display: block;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  img {
    display: inline-block;
  }
}
.modal-close-btn {
  margin-left: 87%;
  margin-bottom: 9px;
  object-fit: contain;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.kyc-container {
  float: left;
  width: 100%;
  min-height: 100vh;
  &--item {
    float: left;
    width: 100%;
    margin-bottom: 28px;
  }
  &--content {
    max-width: 1024px;
    margin: 0 auto;
  }
}
.steps {
  display: block;
}
.number-steps {
  display: none;
}
.section-gray {
  float: left;
  width: 100%;
  padding-bottom: 80px;
}
.kyc-title-header-wrap {
  display: flex;
  justify-content: center;
}
.kyc-title {
  // margin: 35px 0;
  margin: 20px 0;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: #000000;
}
.kyc-subtitle {
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  color: #000000;
}

.kyc-detail-wrap {
  padding: 0 20px;
}
.kyc-detail {
  font-size: 17px;
  text-align: left;
}

.kyc-status-link {
  font-size: 17px;
  font-weight: bold;
  line-height: 50px;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.kyc-icon-maintenance {
  width: 90px;
  height: 90px;
}
.section-white {
  display: block;
  margin: 0 auto;
  padding: 50px;
  max-width: 1024px;
  width: calc(100% - 20px);
  border-radius: 3px;
  box-shadow: 0 0 6px -2px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
.is-button {
  font-size: 17px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.5);
  border: 0;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
}
.next-btn {
  background-color: #0559af;
  width: calc(50% - 20px);
  padding: 13px;
  margin: 24px 10px 0 0;
  float: right;
  max-width: 170px;
}
.full-next-btn {
  background-color: #0559af;
  width: calc(100% - 20px);
  padding: 13px;
  margin: 24px auto;
}

.submit-btn {
  background-color: #50e3c2;
  width: calc(50% - 20px);
  padding: 13px;
  margin: 24px 10px 0 0;
  float: right;
  max-width: 170px;
}

.back-btn {
  background-color: #616161;
  width: calc(50% - 20px);
  padding: 13px;
  margin: 24px 0 0 10px;
  float: left;
  max-width: 170px;
}
/* Less than tablet */
@media only screen and (max-width: 1087px) {
  .kyc-container {
    &--content {
      max-width: 768px;
    }
  }
  .section-white {
    max-width: 768px;
    width: calc(100% - 20px);
    padding: 20px;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .modal-card {
    padding: 0 9px;
  }
  .kyc-container {
    &--content {
      max-width: 768px;
    }
  }
  .section-white {
    width: calc(100% - 20px);
    padding: 30px 15px;
  }
}
/* Custom for steps */
@media only screen and (max-width: 600px) {
  .steps {
    display: none;
  }
  .number-steps {
    display: block;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #0559af;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/KYC/index.vue